import { formatFrontDate } from "@onesolution/utils";
import type { ITask } from "@svar-ui/react-gantt";

export default function TooltipContent({ data }: { data: ITask }) {
  if (!data) return null;

  return (
    <div className="p-2 bg-background" >
      <strong>{data.text}</strong>
      <div>{formatFrontDate(data.start!)} - {formatFrontDate(data.end!)}</div>
    </div>
  );
}
